import { TRAINING_START_WORKOUT_ACTION, TRAINING_START_WORKOUT_DOMAIN, TRAINING_START_WORKOUT_KEY } from 'modules/training/modules/training-start-workout/constants'
import setReduxAction from 'modules/redux/actions/set'

function setCurrentWorkoutSectionAction (value) {
  return setReduxAction({
    type: TRAINING_START_WORKOUT_ACTION.SET_CURRENT_WORKOUT_SECTION,
    payload: {
      path: `${TRAINING_START_WORKOUT_DOMAIN}.${TRAINING_START_WORKOUT_KEY.CURRENT_WORKOUT_SECTION_INDEX}`,
      value
    }
  })
}

export default setCurrentWorkoutSectionAction
